const RatingStars = ({score}) => {
	return (
		<div className="rating-stars flex items-center justify-center gap-x-2">
			<span className={`rating-star ${(score >= 1) && 'full'} ${(score >= 0.5 && score < 1) && 'half'}`}></span>
			<span className={`rating-star ${(score >= 2) && 'full'} ${(score >= 1.5 && score < 2) && 'half'}`}></span>
			<span className={`rating-star ${(score >= 3) && 'full'} ${(score >= 2.5 && score < 3) && 'half'}`}></span>
			<span className={`rating-star ${(score >= 4) && 'full'} ${(score >= 3.5 && score < 4) && 'half'}`}></span>
			<span className={`rating-star ${(score >= 5) && 'full'} ${(score >= 4.5 && score < 5) && 'half'}`}></span>
		</div>
	)
}

export default RatingStars;